import { LocalStorage } from 'quasar';
import { toBoolPreference } from './preferenceBool';

export function getUserDetailFromkey(name: string) {
  let setting_value = '' as string;
  const user_settings = getUserDetails();
  for (const [key, value] of Object.entries(user_settings)) {
    if (key === name) {
      const value_as_string = value as string;
      setting_value = value_as_string;
      break;
    }
  }
  return setting_value;
}

export function getUserDetails() {
  // ✅ FIX: Use Quasar's LocalStorage wrapper, not native localStorage
  // Quasar stores objects with special encoding (__q_objt|...) which needs to be decoded
  // Using Quasar's getItem properly decodes this format before returning
  try {
    const user_settings = LocalStorage.getItem('user_details') as any;

    if (!user_settings || (typeof user_settings === 'object' && Object.keys(user_settings).length === 0)) {
      return {};
    }

     
    return user_settings;
  } catch (error) {
    console.error('Failed to retrieve user details from LocalStorage:', error);
    return {};
  }
}

export function hasDocNetAccess(
  userSettings: Record<string, unknown> | undefined,
): boolean {
  return toBoolPreference(userSettings?.['DOCNET_SETTING']);
}

export function isUserAdmin() {
  const userInfo: any = getUserDetails();

  // Check root level first (legacy/direct storage AND flattened from nested user object)
  if (
    userInfo &&
    userInfo.hasOwnProperty('is_organisation_admin') &&
    userInfo.is_organisation_admin
  ) {
    return true;
  }

  // Check nested user object (profile API response structure - fallback)
  if (
    userInfo &&
    userInfo.user &&
    userInfo.user.hasOwnProperty('is_organisation_admin') &&
    userInfo.user.is_organisation_admin
  ) {
    return true;
  }

  return false;
}

export function isAdmin() {
  const userInfo: any = getUserDetails();
  if (userInfo && userInfo.hasOwnProperty('is_admin') && userInfo.is_admin) {
    return true;
  }

  return false;
}

export function isOrganisationAdmin(): boolean {
  const userInfo: any = getUserDetails();

  // Check both root level and nested user object for is_organisation_admin
  const isOrgAdmin =
    (userInfo?.hasOwnProperty('is_organisation_admin') && userInfo.is_organisation_admin) ||
    (userInfo?.user?.hasOwnProperty('is_organisation_admin') && userInfo.user.is_organisation_admin);

  if (userInfo && isOrgAdmin) {
    const organsations: Array<any> | undefined = userInfo.organisations;
    if (organsations) {
      for (const org of organsations) {
        if (!org.parent_org_id) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  return false;
}

export function isSupplierAdmin() {
  const userInfo: any = getUserDetails();

  // Check both root level and nested user object for is_organisation_admin
  const isOrgAdmin =
    (userInfo?.hasOwnProperty('is_organisation_admin') && userInfo.is_organisation_admin) ||
    (userInfo?.user?.hasOwnProperty('is_organisation_admin') && userInfo.user.is_organisation_admin);

  if (userInfo && isOrgAdmin) {
    const organsations: Array<any> | undefined = userInfo.organisations;
    if (organsations) {
      for (const org of organsations) {
        if (
          org.parent_org_id &&
          org.status === 'approved' &&
          org.is_organisation_admin
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }
  return false;
}

export function isTopLevelUserAdmin() {
  const userInfo: any = getUserDetails();

  // Check both root level and nested user object for is_organisation_admin
  const isOrgAdmin =
    (userInfo?.hasOwnProperty('is_organisation_admin') && userInfo.is_organisation_admin) ||
    (userInfo?.user?.hasOwnProperty('is_organisation_admin') && userInfo.user.is_organisation_admin);

  if (userInfo && isOrgAdmin) {
    const organsations: Array<any> | undefined = userInfo.organisations;
    if (organsations) {
      for (const org of organsations) {
        if (org.parent_org_id) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  }
  return false;
}
export function isManagementUser() {
  const userInfo: any = getUserDetails();

  // Check both root level and nested user object for is_organisation_admin (should be false for management user)
  const isOrgAdmin =
    (userInfo?.hasOwnProperty('is_organisation_admin') && userInfo.is_organisation_admin) ||
    (userInfo?.user?.hasOwnProperty('is_organisation_admin') && userInfo.user.is_organisation_admin);

  if (userInfo && !isOrgAdmin) {
    const organsations: Array<any> | undefined = userInfo.organisations;
    if (organsations) {
      for (const org of organsations) {
        if (org.parent_org_id) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  }
  return false;
}
export function isSupplierUser() {
  const userInfo: any = getUserDetails();
  const organsations: Array<any> | undefined = userInfo.organisations;
  if (organsations) {
    for (const org of organsations) {
      if (org.parent_org_id && org.status) {
        return true;
      }
    }
  }
  return false;
}
/**
 * The supplier's "Supplier Details" route, built from their first org's id.
 * Returns '' for non-supplier users. Used by the settings layout, category
 * view, and hub to link to the supplier register wizard.
 */
export function getSupplierDetailsRoute(): string {
  if (!isSupplierUser()) return '';
  const userInfo: any = getUserDetails();
  const orgId = userInfo?.organisations?.[0]?.org_id || '';
  return `/supplier/register-wizard/supplier_lookup_record_id/${orgId}`;
}
export function contactUsWithCalendly() {
  const email = getUserDetailFromkey('username');
  const first_name = getUserDetailFromkey('first_name');
  const last_name = getUserDetailFromkey('last_name');
  const params = [
    'email=' + email,
    'full_name=' + first_name + ' ' + last_name,
  ];

  window.open(
    'https://calendar.app.google/APGdx8tpizdBAuPZ6?' + params.join('&'),
  );
}

export function getCurrentUserDetails() {
  const id = getUserDetailFromkey('id');
  const email = getUserDetailFromkey('username');
  const first_name = getUserDetailFromkey('first_name');
  const last_name = getUserDetailFromkey('last_name');

  const userFullName = first_name.concat(' ', last_name);

  const userDetails = {
    id: id,
    email: email,
    userFullName: userFullName,
  };

  return userDetails;
}
